export default __webpack_public_path__ + "static/media/Currency.d36c3b28.svg";